module.exports = __webpack_public_path__ + "static/media/ic_column_thumbnail_default.d2eacf03.png";